import { useTranslation } from 'language/translator'

export function useGuidelines() {
  const { t } = useTranslation()

  return [
    {
      title: t('activity_overview', 'clarity_title'),
      body: t('activity_overview', 'clarity_body')
    },
    {
      title: t('activity_overview', 'focus_title'),
      body: t('activity_overview', 'focus_body')
    },
    {
      title: t('activity_overview', 'data_ink_title'),
      body: t('activity_overview', 'data_ink_body')
    },
    {
      title: t('activity_overview', 'rounding_title'),
      body: t('activity_overview', 'rounding_body')
    },
    {
      title: t('activity_overview', 'grouping_title'),
      body: t('activity_overview', 'grouping_body')
    },
    {
      title: t('activity_overview', 'consistency_title'),
      body: t('activity_overview', 'consistency_body')
    },
    {
      title: t('activity_overview', 'hierarchy_title'),
      body: t('activity_overview', 'hierarchy_body')
    },
    {
      title: t('activity_overview', 'context_title'),
      body: t('activity_overview', 'context_body')
    },
    {
      title: t('activity_overview', 'labels_title'),
      body: t('activity_overview', 'labels_body')
    },
    {
      title: t('activity_overview', 'human_title'),
      body: t('activity_overview', 'human_body')
    }
  ]
}
